import { useMemo } from 'react'
import { useProfile } from 'src/modules/user/hooks/use-profile'
import {
  type MessageLanguage,
  resolveProfileMessageLanguage,
} from 'src/modules/user/utils/resolve-profile-message-language'

/** The message language from the profile cache, and the template's when given; English until the profile loads. */
export function useMessageLanguage(templateLanguage?: string | null): MessageLanguage {
  const { data: profile } = useProfile()
  const messageLanguage = profile?.message_language ?? null
  const countryCode = profile?.default_country_code ?? null

  return useMemo(
    () =>
      resolveProfileMessageLanguage(
        { message_language: messageLanguage, default_country_code: countryCode },
        templateLanguage,
      ),
    [messageLanguage, countryCode, templateLanguage],
  )
}
